import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport } from 'owa-bundling';
import type { MailboxInfo } from 'owa-client-types';
import type { QuickStepItem, QuickStepHotkeyId } from 'owa-quick-step-types';
import type { QuickStepReturnInfo } from './selectors/getQuickStepById';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "QuickSteps" */ './lazyIndex'),
    { name: 'QuickSteps' }
);

// Lazy action
export const lazyAddQuickStep: LazyImport<
    (mailboxInfo: MailboxInfo, quickStep: QuickStepItem) => void,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.addQuickStep);
export const lazyRemoveQuickStep: LazyImport<
    (mailboxInfo: MailboxInfo, index: number) => void,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.removeQuickStep);
export const lazyMoveQuickStep: LazyImport<
    (mailboxInfo: MailboxInfo, currentIndex: number, moveUp: boolean, originIndex?: number) => void,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.moveQuickStep);
export const lazySetQuickStepsRunOnce: LazyImport<
    (mailboxInfo: MailboxInfo) => void,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.setQuickStepsRunOnce);
export const lazyGetQuickStepActionsByHotkey: LazyImport<
    (mailboxInfo: MailboxInfo, hotkey: QuickStepHotkeyId) => Promise<QuickStepReturnInfo>,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getQuickStepActionsByHotkey);
export const lazyGetQuickStepActionsById: LazyImport<
    (mailboxInfo: MailboxInfo, id: string) => QuickStepReturnInfo,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getQuickStepActionsById);
export const lazyLoadMailboxQuickSteps: LazyImport<
    (mailboxInfo: MailboxInfo) => Promise<void>,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.loadMailboxQuickSteps);
